/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function BudgetEstimate2026_2027Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Elections Nova Scotia 2026-2027 Budget Estimate"
              description={
                <>
                  <h4>
                    On January 14, 2026, Li Chao, the Chief Financial Officer for Elections Nova Scotia (ENS) presented a budget estimate of $7.971 million for the 2026-2027 fiscal year to the Special Committee of the House of Assembly that convenes annually by law to consider the budget submissions of ENS and the Auditor General.
                  </h4>
                  <br /><p>ENS’s 2026-2027 budget submission includes an additional $3.5 million, which  is required to continue to fulfill our mandate. This amount includes: </p>
                  <ul style={{ paddingLeft: "40px" }}>
                  <br /><p>1. $2.4M - Preparation for the 43rd Provincial General Election including in-person training for returning office staff, equipment procurement, polling division reviews, media and communications support, and materials production. </p>
                  <br /><p>2. $750K – Delivery of up to three potential by-elections.  </p>
                  <br /><p>3.	$364K – Service delivery projects including implementation of the outreach strategy, voter registration initiatives during Registration Month, and development of a new website to ensure accessible online services.</p>
                  <br /><p>4.	$60K - External legal counsel essential to preserve the independence of the office and address unforeseen litigation or compliance matters.</p>
                  </ul>
                  <br /><p>The Special Committee reviewed ENS’s budget estimate and recommended it without alteration to Finance, Treasury and Policy Board to be included in the 2026-2027 provincial budget.</p>
                  <br /><u><a href="/files/AnnualAndOtherReports/ENS_2026-2027_BudgetEstimates_FINAL.pdf">Please click here to view the 2026-2027 budget estimates.</a></u>
                  {/* <li><u><a href={`${process.env.PUBLIC_URL}/files/ENS_Budget_SC_CFOSpeakingNotes_Jan 29_2025.pdf`}>Speaking Notes for the Chief Financial Officer as presented to the Special Committee of the House of Assembly on January 29, 2025</a></u></li> */}
                  {/* <br /> */}
                  <br />
                  ENS is an independent non-partisan agency that reports to the members of the House of Assembly through the Speaker. Its mandate is to deliver provincial elections impartially and professionally.
 
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default BudgetEstimate2026_2027Information;
